/**
 * 选课路由
 */
export default [
  {
    path: '/course/index',
    name: 'CourseIndex',
    component: (resolve) => require(['@/views/course/home/index'], resolve),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/course/search',
    name: 'CourseSearch',
    component: (resolve) => require(['@/views/course/home/search'], resolve)
  },
  {
    path: '/course/search/details',
    name: 'CourseSearchDetails',
    component: (resolve) => require(['@/views/course/home/search-details'], resolve)
  },
  {
    path: '/course/course/more',
    name: 'courseMore',
    component: (resolve) => require(['@/views/course/home/course-more'], resolve)
  },
  {
    path: '/course/group',
    name: 'CourseGroup',
    component: (resolve) => require(['@/views/course/home/course-group'], resolve)
  },
  {
    path: '/course/details',
    name: 'courseDetails',
    component: (resolve) => require(['@/views/course/details/index'], resolve)
  },
  {
    path: '/course/courseSheet',
    name: 'CourseSheet',
    meta: {
      title: '选课单',
      keepAlive: true, // /此组件需要缓存
      isBack: false // 用来判断是否是返回上一页
    },
    component: (resolve) => require(['@/views/course/sheet/courseSheet'], resolve)
  },
  /**
     * 课程-课程促销
     */
  {
    path: '/course/promotionCourse',
    name: 'PromotionCourse',
    component: (resolve) => require(['@/views/mine/promotionCourse'], resolve),
    meta: { title: '课程促销' }
  },
  /**
     * 课程-可选赠课
     */
  {
    path: '/course/freeClass',
    name: 'FreeClass',
    component: (resolve) => require(['@/views/course/freeClass/index'], resolve),
    meta: { title: '可选赠课' }
  },
  /**
     * 课程-续报优惠
     */
  {
    path: '/course/xubaoCourse',
    name: 'XubaoCourse',
    component: (resolve) => require(['@/views/mine/xubaoCourse'], resolve),
    meta: { title: '续报优惠' }
  }
];




// WEBPACK FOOTER //
// ./src/router/modules/course.js